/** Types allowed as the root level components of an export. */
export enum ExportComponentType {
  intent = 'INTENT',
  module = 'MODULE',
  prompt = 'PROMPT',
  schema = 'SCHEMA',
  url = 'URL',
  variable = 'VARIABLE'
}
